import type { ReactNode } from 'react';
import { motion } from 'motion/react';

interface PulsoDuasProps {
  children: ReactNode;
  className?: string;
}

// Pulsa duas vezes ao abrir a tela — e para. Nunca fica em loop, para não
// cansar quem usa a ferramenta o dia inteiro.
export default function PulsoDuas({ children, className = '' }: PulsoDuasProps) {
  return (
    <motion.span
      className={className}
      initial={{ scale: 1 }}
      animate={{ scale: [1, 1.18, 1, 1.18, 1] }}
      transition={{ duration: 0.7, ease: 'easeInOut', times: [0, 0.22, 0.5, 0.72, 1] }}
    >
      {children}
    </motion.span>
  );
}